<template>
	<div class="sidebar-fix-outer">
		<span v-if="$store.state.sidebarStatus == 'false'" class="sidebar-handle" @click="sideFoldClick"></span>
		<span v-if="$store.state.sidebarStatus == 'true'" class="sidebar-handle" @click="sideOpenClick"></span>
		<div class="sidebar-fix">
			<h3>云数据库</h3>
			<ul>
				<li><a v-bind:href="linkRds">MySQL</a></li>
				<li><a v-bind:href="linkRedis">Redis</a></li>
				<li class="drop-block" v-if="$store.state.activateStatus == 'true'">
					<a class="bar-num">Memcached</a>
					<p>
						<router-link to="/hosts">实例列表</router-link>
						<router-link to="/roster">白名单</router-link>
						<router-link to="/log">操作审计</router-link>
					</p>
				</li>
				<li v-else>
					<a>Memcached</a>
				</li>
			</ul>
		</div>
	</div>
</template>

<script setup>
		import { ref } from 'vue';
		import { useStore } from 'vuex';
		
		const store = useStore();
		const host = window.location.host;
		let linkRds = '';
		let linkRedis = '';
		if (host.includes('-p')) {
			linkRds = 'https://rds-p.console.landui.com/';
			linkRedis = 'https://cache-p.console.landui.com/';
		}else if(host.includes('st')){
			linkRds = 'https://rds.st.landui.cn/';
			linkRedis = 'https://cache.st.landui.cn/';
		}else{
			linkRds = 'https://rds.console.landui.com/';
			linkRedis = 'https://cache.console.landui.com/';
		}
		
		
		const sideFoldClick = () => {
			store.commit("setsideStatus", 'true');
		};
		const sideOpenClick = () => {
			store.commit("setsideStatus", 'false');
		};
</script>


